// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"270":"92a12c44","404":"193e8d4f"}[chunkId] + ".chunk.js";
};